import { faHeart, faStar } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { toastSuccess } from 'app/utils/toastHelper';
import { useDispatch, useSelector } from 'react-redux';
import * as commonActions from 'app/actions/commons';
import Image from 'app/components/layouts/Image';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import * as listenApi from 'app/requests/listens';
import { useState, useEffect } from 'react';
import storage from 'app/utils/storage';
import { Song } from 'types/music';
import uniq from 'lodash/uniq';
import Link from 'next/link';
import env from '.env.json';
import 'app/components/music/wrap-box.css'

const ListMusic = ({ musics, pushUrl }) => {
  const { auth } = useSelector((state: AppStoreState) => state.global);
  const [songIdsLove, setSongIdsLove] = useState<string[]>([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    let songIds = storage.get("songIds") || '';
    setSongIdsLove(songIds.split(','));
  }, []);

  const updateSongHot = async (e: React.MouseEvent<SVGSVGElement, MouseEvent>, id: string) => {
    e.preventDefault()
    try {
      dispatch(commonActions.setLoading(true));
      await listenApi.updateSongHot(id);
      pushUrl();
      toastSuccess('Update video hot success');
    } catch (error) {
      console.error('List music: ', error);
    } finally {
      dispatch(commonActions.setLoading(false));
    }
  }

  const loveVideo = async (e: React.MouseEvent<SVGSVGElement, MouseEvent>, id: string, isAdd: boolean) => {
    e.preventDefault()
    let songIds = storage.get("songIds") || '';
    songIds = songIds.split(',');
    if (isAdd && songIds.includes(id)) return;

    if (isAdd) {
      songIds = uniq([...songIds, id])
      toastSuccess(t('song.like'));
    } else {
      songIds = songIds.filter((item: string) => item != id);
      toastSuccess(t('song.un_like'));
    }

    setSongIdsLove(songIds);
    songIds = songIds.join();
    storage.set("songIds", songIds);
  }

  return (
    <div className="mt-2 row mx-1">
      {
        (musics || []).map((music: Song) => {
          const isLove = songIdsLove.includes(music._id);
          return (
            <div className='col-md-4 col-sm-6 col-xs-6 px-2 center-box' key={music._id}>
              <div className={`mb-3 wrap-box-content wrap-box-song`}>
                <Link href={`/song/${music.slug}`}>
                  <div className="m-1">
                    <div className='position-relative video-box'>
                      <Image
                        className="image-song my-auto"
                        alt={music.title}
                        src={`${env.URL_API_FILE}/${music.songImage}`}
                      />
                      <Image
                        className="img-play-video"
                        alt="icon-play"
                        src="/images/commons/play.webp"
                      />
                      <div className='action-icon-video'>
                        <FontAwesomeIcon
                          onClick={(e) => loveVideo(e, music._id, !isLove)}
                          className={`heart-video d-block ${isLove ? 'text-danger' : 'text-success'}`} icon={faHeart}
                        />

                        {auth.role === 'admin' &&
                          <FontAwesomeIcon
                            onClick={(e) => updateSongHot(e, music._id)}
                            className={music.hot ? 'text-warning' : 'text-secondary'} icon={faStar}
                          />
                        }
                      </div>
                    </div>
                    <div className="overflow-hidden mt-1">
                      <div className="wrap-box-title text-left">
                        {music.title}
                      </div>
                      <small className="float-left">{music.singerName}</small>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ListMusic;
